import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/de';

@Pipe({
  name: 'DateFormat'
})

@Injectable()
export class DateFormatPipe implements PipeTransform {
  transform(date: any, args?: any): any {
    let m = moment(new Date(date));
    if(m.diff(new Date(), 'days') <= -7) {
      return m.format('L');
    } else {
      return m.fromNow();
    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/date.ts